import { sizing, type SizingProps } from '@material-ui/system'
import { em, rem } from 'polished'
import styled from 'styled-components'

interface IPdfViewerStyledProps extends SizingProps {}

export const PdfViewerStyled = styled.div<IPdfViewerStyledProps>`
  font-size: ${rem(16)};
  ${sizing}
`
